export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AcNotice.vue?vue&type=template&id=10ae82a7"


//////////////////
// WEBPACK FOOTER
// ./admin/src/js/components/AcNotice.vue?vue&type=template&id=10ae82a7
// module id = 28
// module chunks = 0